import React from 'react';
import { Asterisk } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/7inTevuhRF6mEgasSL53Js/Untitled_(1880_x_940_px).png';

// The logo file is used as a mask so it renders in brand gold.
const logoMask = {
  WebkitMaskImage: `url("${LOGO_URL}")`,
  maskImage: `url("${LOGO_URL}")`,
  WebkitMaskRepeat: 'no-repeat',
  maskRepeat: 'no-repeat',
  WebkitMaskPosition: 'center',
  maskPosition: 'center',
  WebkitMaskSize: 'contain',
  maskSize: 'contain'
} as React.CSSProperties;
export function Marquee() {
  const count = 6;
  const logos = Array.from({
    length: count
  });
  const Logo = ({
    index
  }: {
    index: number;
  }) => <div className="flex items-center shrink-0" data-id="element-110" data-mp="31c893f78x2ri">
      <span role="img" aria-label="En2Action" key={index} style={logoMask} className="block bg-foodGold h-16 w-32 sm:h-20 sm:w-40 mx-8" data-id="element-111" data-mp="2x9bpbl5yz0lz" />
      <Asterisk className="text-foodGold shrink-0" size={32} data-id="element-112" data-mp="1lsvfq8h3je71" />
    </div>;
  return <div className="bg-foodMaroon py-6 overflow-hidden border-y-4 border-foodMaroon" data-id="element-113" data-mp="2thksyn8httyo">
      <div className="flex w-max animate-marquee items-center" data-id="element-114" data-mp="2tfi260zinwsw">
        {/* First set */}
        {logos.map((_, index) => <Logo key={`a-${index}`} index={index} data-id="element-115" data-mp="2kh697sb6gmxa" data-mpi={index} />)}
        {/* Duplicate set for seamless loop */}
        {logos.map((_, index) => <Logo key={`b-${index}`} index={index} data-id="element-116" data-mp="2ogf10rmnqaq7" data-mpi={index} />)}
      </div>
    </div>;
}